'use strict';

import {alert} from '../../../src/alerts';

export function navigation() {
    if (window.location.hash.indexOf('comments') !== -1) {
        $('#tabs_details-wrapper .tab2 A').click();

        setTimeout(function () {
            $(window).scrollTop($('#tabs_details-wrapper .tab2 A').offset().top);
        }, 100);
    }

    if (window.location.hash.indexOf('answer_') !== -1) {
        const id = parseInt(window.location.hash.replace('#answer_', ''));

        $('#tabs_details-wrapper .tab2 A').click();

        setTimeout(function () {
            $(window).scrollTop($('#tabs_details-wrapper .review_block [data-id="' + id + '"]').offset().top);
        }, 500);
    }
}

export function create(goods_id, answer) {
    var comName = $('#goodsCommentName' + answer).val();
    var comText = $('#goodsCommentText' + answer).val();

    if (comName.length < 3) {
        // Укажите имя которое будет состоять не менее чем из 3-х символов
        alert(trans('good.reviews.name_short'), trans('good.reviews.name_short_caption'));
    } else if (comText.length < 20) {
        // Комментарий должен содержать не менее чем 20 символов
        alert(trans('good.reviews.comment_short'), trans('good.reviews.comment_short_caption'));
    } else if (goods_id > 0) {
        $('#goodsCommentsWaite' + answer).show();

        $.post(
            '/good/review/add/',
            {good_id: goods_id, name: comName, text: comText, parent: answer},
            function (response) {
                if (response.status === 'success') {
                    var time = $('#goodsCommentText').data('time');

                    $('#goodsCommentsWaite' + answer).hide();
                    $('#goodsCommentName' + answer).val('');
                    $('#goodsCommentText' + answer).val('');

                    if (answer > 0) {
                        var div = `		<div data-id="44" class="view" style="margin-left: 50px; margin-top: 0; background-color: #f5f5f5; width: 860px">
                                        <div class="top_block">
                                            <div class="name">${comName}</div>
                                            <div class="date">${time}</div>
                                            <div class="review_top"></div>
                                        </div>
                                        <div class="wrap">${response.text}</div>
                                    </div>`;

                        $('#answForm' + answer).after(div);
                        $('#answForm' + answer).hide();
                    } else {
                        var div = `	<div class="view" itemprop="review" itemscope itemtype="http://schema.org/Review">
                                    <div class="top_block">
                                        <div class="name" itemprop="author">${comName}</div>
                                        <div class="date" itemprop="datePublished">${time}</div>
                                        <div class="review_top"></div>
                                    </div>
                                    <div class="wrap">
                                        <div itemprop="description">${response.text}</div>
                                    </div>
                                </div>
                                <div class="clear"></div>`;

                        $('.review_block').find('div[itemprop="aggregateRating"]');

                        var reviewBlock = $('.review_block');

                        if (reviewBlock.find('div[itemprop="aggregateRating"]').length) {
                            reviewBlock.find('div[itemprop="aggregateRating"]').after(div);
                        } else {
                            reviewBlock.prepend(div);
                        }
                    }
                } else {
                    $('#goodsCommentsWaite' + answer).hide();

                    // Произошла ошибка
                    alert(trans('good.reviews.error_happened'));
                }
            }
        );
    }
}
